import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({
  element: Component,
  isAuthenticated,
  layout: Layout,
  ...rest
}) => {
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return Layout ? <Layout>{Component}</Layout> : Component;
};

export default PrivateRoute;
